<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>流程列表</h4>
        </div>
        <div class="mg20" >
            <div class="main-bd">
                <el-tabs v-model="activeTab" @tab-click="handleClick">
                    <el-tab-pane  label="正式订单" name="formal"></el-tab-pane>
                    <el-tab-pane  label="试用订单" name="trial"></el-tab-pane>
                </el-tabs>
                <el-row class="searchSection">
                    <el-form :model="search_form" ref="form" :rules="rules" :inline="true">
                        <el-form-item>
                            <el-button type="primary" size="small" @click="create">+ 添加新流程</el-button>
                        </el-form-item>
                        <el-form-item label="流程名称">
                            <FlowSelect v-model="search_form.search_name"
                            @change="flowHandleChange" :activeTab="activeTab"></FlowSelect>
                        </el-form-item>
                        <el-form-item label="流程类型">
                            <el-select v-model="search_form.type" size="small" style="width: 110px;">
                                <el-option label="产品线" value="1"></el-option>
                                <el-option label="财务线" value="2"></el-option>
                                <el-option label="合同线" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button  type="primary" @click="getFlowService()">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-table :data="flows" style="width: 100%" v-loading="loading">
                    <el-table-column prop="nodes" type="expand" >
                        <template slot-scope="scope">
                            <el-steps :active="9">
                                <slot v-for="value in scope.row.nodes" >
                                    <el-step :title="value.executor_memo" ></el-step>
                                </slot>
                                <el-step title="完成" ></el-step>
                            </el-steps>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="流程ID"></el-table-column>
                    <el-table-column prop="name" label="流程名称">  <template slot-scope="scope">
                        <div v-html="scope.row.name"></div>
                    </template></el-table-column>
                    <el-table-column prop="type" label="流程类型">
                        <template slot-scope="scope">
                            <p>{{flows_type[scope.row.type-1].label}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="desc" label="简介"></el-table-column>
                    <el-table-column prop="status_memo" label="流程状态"></el-table-column>
                    <el-table-column prop="created_at" label="添加时间"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope" >
                            <div>
                                <el-button @click="handleEdit(scope.row)"  type="text" size="small">编辑</el-button>
                                <el-button @click="handleDelete(scope.row.id)"  type="text" size="small">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- Form -->
                <el-dialog title="流程设置" :visible.sync="dialogFormVisible" width="80%" center>
                    <el-form :model="form" :rules="rules" ref="form" :key="form.id">
                        <el-form-item label="流程名称" prop="name" :label-width="formLabelWidth">
                            <el-input v-model="form.name" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="Id" prop="id" hidden :label-width="formLabelWidth">
                            <el-input v-model="form.id" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="流程介绍" prop="desc" :label-width="formLabelWidth">
                            <el-input v-model="form.desc" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="流程状态" prop="status" :label-width="formLabelWidth">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="流程类型" prop="type" :label-width="formLabelWidth">
                            <el-select v-model="form.type" placeholder="请选择">
                                <el-option
                                        v-for="item in flows_type"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="抄送人设置" prop="copy_to" :label-width="formLabelWidth">
                            <UserSelectCorp :is-multiple="true" :uid="form.copy_to" :aria-readonly="true " @change="CopyTo"></UserSelectCorp>
                        </el-form-item>
                        <el-form-item v-if="this.activeTab == 'trial'" label="开通产品" prop="products" :label-width="formLabelWidth">
                                <el-checkbox-group  v-model="productChecked" @change="productChange"
                                                   class="product-use">
                                    <el-checkbox v-for="product in products"
                                                 :key="product.id"
                                                 :value="product.id"
                                                 :label="product.id">{{product.name}}
                                    </el-checkbox>
                                </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="节点设置" prop="nodes" :label-width="formLabelWidth">
                            <el-button type="text" @click="addNode">添加节点</el-button>
                            <node-table :nodes="form.nodes" @handleDel="handleDelNode" :activeTab="activeTab" @handleUser="handleUser" ></node-table>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitForm" :loading="loading">确 定</el-button>
                    </div>
                </el-dialog>
                <el-row v-if="linkPage">
                    <pagination :linkPage="linkPage"></pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import CommonService from "~/services/common";
    import FlowService from "~/services/flow";
    import NodeTable from "~/views/flow/node.vue";
    import UserSelectCorp from "~/widgets/UserSelectCorp.vue";
    import FlowSelect from "~/widgets/FlowSelect.vue";

    export default {
        components: {
            FlowSelect,
            Pagination,
            NodeTable,
            UserSelectCorp
        },

        data() {
            /**@description 验证节点 */
            var validateNode = (rule, value, callback) => {
                this.form.nodes.forEach(item => {
                    if (item.executor_id == '' || typeof(item.executor_id) == "undefined") {
                        callback(new Error("执行人不能为空"));
                    }
                });
                callback();
            };
            return {
                linkPage: null,
                flows: [], //流程列表
                flows_type: [{
                    value: 1,
                    label: '产品线'
                }, {
                    value: 2,
                    label: '财务线'
                },{
                    value: 3,
                    label: '合同线'
                }],
                dialogFormVisible: false,
                options: [{
                    value: 0,
                    label: '关闭'
                }, {
                    value: 1,
                    label: '启用'
                }],
                form: {
                    id: '',
                    type:'',
                    name: '',
                    desc: '',
                    nodes: [],
                    copy_to:[],
                    products:[],
                    order_type:0
                },
                search_form:{
                    search_name: '',
                    type: ''
                },
                formLabelWidth: '120px',
                rules: {
                    nodes: [
                        {validator: validateNode, trigger: 'submit'}
                    ],
                    type: [
                        {required: true, message: '请选择流程类型', trigger: 'blur'},
                    ],
                    name: [
                        {required: true, message: '请填写流程名称', trigger: 'blur'},
                    ],
                },
                activeTab: 'formal',
                products:[],
                productChecked: [],
                loading: false,
            };
        },
        /**
         * 监听组件切换变化
         */
        watch: {
            $route(to, from) {
                let params = this.searcherModel;
                this.currentUseTab = this.activeTab;
                params['tab'] = this.activeTab;
                params['page'] = to.query["page"];
                params['perPage'] = to.query["perPage"];
            },

        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {

            this.initListData({
                page: to.query["page"],
                perPage: to.query["perPage"]
            });
        },
        mounted() {

            this.initListData();
        },
        methods: {
            flowHandleChange(object) {
                this.search_form.search_name = object.value;
            },
            //删除产品操作
            handleDelete(id) {
                this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                        FlowService.del(id).then(res => {
                            let text = {
                                message: '删除成功',
                                type: 'success'
                            }
                            if(res.code){
                                text.message = res.msg,
                                text.type = 'error'
                            }
                            this.$message(text);
                            this.flows = this.flows.filter(function (item) {
                                return item.id != id;
                            });
                            this.initListData();
                        })
                    })
                    .catch(() => {
                    });
            },
            productChange(value) {
                this.productChecked = value;
                this.form.products = value;
            },
            //表单提交
            submitForm() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if (this.form.id) {
                            this.save();
                        } else {
                            this.addFlow();
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //添加产品弹窗
            create() {
                this.form = {};
                this.form.nodes = [];
                this.dialogFormVisible = true
            },
            //添加新流程
            addFlow() {
                this.loading = true;
                if(this.activeTab == 'trial') {
                    this.form.order_type =1
                }
                FlowService.create(this.form).then(res => {
                    if (res.code == 0) {
                        this.flows.unshift(res.data);
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        this.initListData();
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            CopyTo($event){
                this.form.copy_to = $event;
            },
            //编辑
            handleEdit(data) {
                this.dialogFormVisible = true;
                this.productChecked =  data.products;
                this.form = Object.assign({}, data);
            },
            //保存操作
            save() {
                this.loading = true;
                var data = Object.assign({}, this.form);
                if(data.products && data.products.length > 0){
                    data.products = data.products.filter(function (item) {
                        return item > 0;
                    });
                    if(!data.products || data.products.length == 0){
                        this.$delete(data,'products');
                    }
                }
                var i = this.flows.findIndex(function (item) {
                    return item.id == data.id;
                });
                FlowService.update(data).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.flows = [...this.flows.slice(0, i), res.data, ...this.flows.slice(i + 1)];
                    }
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            //默认加载
            initListData(params = {}) {
                let order_type = 0
                if(this.activeTab == 'trial') {
                    order_type = 1;
                }
                this.loading = true;
                //加载流程列表
                FlowService.getList({
                    name: this.search_form.search_name,
                    type: this.search_form.type,
                    order_type:order_type,
                    page: params.page,
                    perPage: params.perPage
                }).then(res => {
                    this.flows = res.data
                    this.linkPage = res._meta;
                    this.loading = false;
                });
                //加载产品列表
                CommonService.getProducts({
                    is_deleted: 0,
                    fields: 'id,name,price,code'
                }).then(res => {
                    this.products = res.data
                });
            },
            getFlowService(params = {}){
                let order_type = 0
                if(this.activeTab == 'trial') {
                    order_type = 1;
                }
                this.loading = true;
                FlowService.getList({
                    name: this.search_form.search_name,
                    type: this.search_form.type,
                    order_type:order_type,
                    page: params.page,
                    perPage: params.perPage
                }).then(res => {
                    this.flows = res.data
                    this.linkPage = res._meta;
                    this.loading = false;
                });
            },
            /**
             * 删除节点
             * @param id
             */
            handleDelNode(key){
                this.form.nodes = this.form.nodes.filter(function (item) {
                    return item.key != key;
                });
                this.form.nodes = this.form.nodes.map(function (item,index) {
                    item.key = index+1;
                    return  item;
                });
                this.form = Object.assign({}, this.form)
            },
            /**
             *操作人
             */
            handleUser(user,key){
                let node_key = this.form.nodes.findIndex(function (item) {
                    return item['key'] == key;
                });
                this.form.nodes[node_key]['executor_id'] = user.label;
                this.form.nodes[node_key]['executor_memo'] = user.value;
            },
            /**
             * 添加节点操作
             */
            addNode(){
                let last_node = _.last(this.form.nodes);
                let key = last_node?last_node.key:0;
                this.form.nodes.push({
                    "key":  key + 1,
                    "executor_id":'',
                    'executor_memo':'',
                    check_rule:{
                        check_pass:"3",
                        check_no:"3",
                    }
                });
            },
            handleClick: function (tab, event) {
                this.activeTab = tab.name;
                this.search_form = {
                    search_name:'',
                    type: '',
                }
                let order_type = 0
                if(this.activeTab == 'trial') {
                    order_type = 1;
                }
                this.loading = true;
                FlowService.getList({
                    name: this.search_form.search_name,
                    type: this.search_form.type,
                    order_type: order_type,
                }).then(res => {
                    this.flows = res.data
                    this.linkPage = res._meta;
                    this.loading = false;
                });


            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/flow/index.vue